import ReactDOMServer from "react-dom/server";
import { geometryUtils } from "../utils/geometryUtils";

export const SunlightPatchesRenderer = ({
  openingsData,
  svgDimensions,
  rotationAngleDeg,
	insolationAngle
}) => {

  const sunPatchDistance = 250;

  const sunAngle = insolationAngle - rotationAngleDeg;
  const svgHeight = svgDimensions.height;
  const svgWidth = svgDimensions.width;
  const {
    rotatePointClockwise,
    lineIntersection,
    constructParallelogram,
    getGradientCoordinates,
  } = geometryUtils();
  const gradientCoordinates = getGradientCoordinates(rotationAngleDeg);

  const getTransformedVertexes = (data, correction) => {
    const angle = data.angle;
    const boundary = data.boundary;
    const center = data.insert_point;
    const transformedBoundary = boundary.map(([x, y]) => {
      const rotatedPoint = rotatePointClockwise(x, y, angle, 0, 0);
      const translatedPoint = {
        x: rotatedPoint.x + center[0],
        y: rotatedPoint.y + (correction - center[1]), //correction now equals 0. y axis flipped twice?
      };
      return [translatedPoint.x, translatedPoint.y];
    });

    return {
      ...data,
      transformedBoundary,
    };
  };
  const windows = openingsData.map((window) =>
    getTransformedVertexes(window, 0) //old correction now causes a bug. y axis flipped twice?
  );

  const isWindowIlluminated = (window) => {
    //Convert insolationAngle (angle) to an hour
    const hour = (insolationAngle - 90) / 15 + 6;

    //Check if the derived hour falls within any of the ranges in sun_light_ranges
    if (!window.sun_light_ranges || window.sun_light_ranges.length === 0) {
      return false;
    }

    return window.sun_light_ranges.some(([start, end]) => {
      return hour >= start && hour <= end;
    });
  };

  const findCommonPart = (window, angle) => {
    const vertexes = window.transformedBoundary;
    const parallelogramA = constructParallelogram(
      vertexes,
      0,
      1,
      angle,
      sunPatchDistance
    );
    //parallelogramA form vertexes indexes 0 and 1 = [0, 1, 1', 0']
    const parallelogramB = constructParallelogram(
      vertexes,
      2,
      3,
      angle,
      sunPatchDistance
    );
    //parallelogramB form vertexes indexes 2 and 3 = [2, 3, 3', 2']

    const A0ToA0prime = [parallelogramA[0], parallelogramA[3]];
    const A0primeToA1prime = [parallelogramA[3], parallelogramA[2]];
    const B0ToB1 = [parallelogramB[0], parallelogramB[1]];
    const B0ToB0prime = [parallelogramB[0], parallelogramB[3]];
    const B1ToB1prime = [parallelogramB[1], parallelogramB[2]];

    const firstIntersection = lineIntersection(A0ToA0prime, B0ToB1);
    const secondIntersection = lineIntersection(A0primeToA1prime, B1ToB1prime);
    const thirdIntersection = lineIntersection(A0primeToA1prime, B0ToB0prime);

    if (firstIntersection) {
      return [
        parallelogramA[0],
        parallelogramA[1],
        parallelogramB[0],
        thirdIntersection,
        parallelogramA[3],
      ];
    } else if (secondIntersection) {
      return [
        parallelogramA[0],
        parallelogramA[1],
        parallelogramA[2],
        secondIntersection,
        parallelogramB[1],
      ];
    } else {
      return [];
    }
  };

  const rayPathStringFromCoordinatesArray = (arr) => {
    if (!arr || arr.length === 0) return "";

    let pathString = `M ${arr[0][0]} ${arr[0][1]}`;
    for (let i = 1; i < arr.length; i++) {
      pathString += ` L ${arr[i][0]} ${arr[i][1]}`;
    }
    pathString += " Z";

    return pathString;
  };

  const generateSvgElements = () => {
    return (
      <>
        <g data-layer="sunlight-patches">
          {windows.map((window, index) => {
            return (
              <g key={index} data-layer={`${window.id_hex}_patch`}>
                {isWindowIlluminated(window, sunAngle) ? (
                  <path
                    style={{ pointerEvents: "none" }}
                    d={rayPathStringFromCoordinatesArray(
                      findCommonPart(window, sunAngle)
                    )}
                    fill={`url(#gradAngle)`}
                  />
                ) : null}
              </g>
            );
          })}
          <defs> 
						{/*TODO: BUG FIX gradient is broken and not shining form the window*/}
            <lineargradient
              id={`gradAngle`}
              x1={gradientCoordinates.x1}
              y1={gradientCoordinates.y1}
              x2={gradientCoordinates.x2}
              y2={gradientCoordinates.y2}
              gradientUnits="objectBoundingBox"
            >
              <stop
                offset="0%"
                style={{ stopColor: "rgb(255 200 0)", stopOpacity: 0 }}
              />
              <stop
                offset="100%"
                style={{ stopColor: "rgb(255 200 0)", stopOpacity: 0.6 }}
              />
            </lineargradient>
          </defs>
        </g>
      </>
    );
  };

  const svgElements = ReactDOMServer.renderToStaticMarkup(
    generateSvgElements()
  );

  return svgElements;
};
